import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';
import Button from '../../../components/ui/Button';
import Select from '../../../components/ui/Select';

const BulkResultEntry = ({ matches, onBulkSubmit }) => {
  const [selectedMatches, setSelectedMatches] = useState([]);
  const [isProcessing, setIsProcessing] = useState(false);

  const matchOptions = matches?.filter(match => match?.status === 'pending')?.map(match => ({
      value: match?.id,
      label: `Match #${match?.matchNumber}: ${match?.team1} vs ${match?.team2}`,
      description: new Date(match.date)?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })
    }));

  const handleBulkSubmit = async () => {
    setIsProcessing(true);
    await onBulkSubmit(selectedMatches);
    setIsProcessing(false);
    setSelectedMatches([]);
  };

  return (
    <div className="bg-card rounded-lg border border-border p-4 md:p-6">
      <div className="flex items-center gap-3 mb-6">
        <div className="w-10 h-10 rounded-lg bg-primary/10 flex items-center justify-center">
          <Icon name="Layers" size={20} className="text-primary" />
        </div>
        <div>
          <h3 className="text-lg font-semibold text-foreground">Bulk Result Entry</h3>
          <p className="text-sm text-muted-foreground">
            Process multiple match results at once
          </p>
        </div>
      </div>
      <div className="space-y-4">
        <Select
          label="Select Matches"
          description="Choose matches with pending results"
          options={matchOptions}
          value={selectedMatches}
          onChange={setSelectedMatches}
          multiple
          searchable
          placeholder="Search and select matches..."
        />

        {selectedMatches?.length > 0 && (
          <div className="bg-muted rounded-lg p-4">
            <p className="text-sm text-foreground mb-2">
              <span className="font-medium">{selectedMatches?.length}</span> match{selectedMatches?.length !== 1 ? 'es' : ''} selected
            </p>
            <p className="text-xs text-muted-foreground">
              Results will be processed sequentially with automated points calculation
            </p>
          </div>
        )}

        <div className="flex flex-col sm:flex-row gap-3">
          <Button
            variant="outline"
            onClick={() => setSelectedMatches([])}
            disabled={selectedMatches?.length === 0}
            className="flex-1 sm:flex-initial"
          >
            Clear Selection
          </Button>
          <Button
            variant="default"
            onClick={handleBulkSubmit}
            loading={isProcessing}
            disabled={selectedMatches?.length === 0}
            iconName="Upload"
            iconPosition="left"
            className="flex-1 sm:flex-initial"
          >
            Process Results
          </Button>
        </div>
      </div>
    </div>
  );
};

export default BulkResultEntry;